import React from 'react'

import _ from 'lodash'

import CustomerActions from '../../actions/CustomerActions.js'
import AddressActions from '../../actions/AddressActions.js'
import LoginActions from '../../actions/LoginActions.js'

import {Alert, Button, Tabs, Tab, Popup, IconButton, Modal, ModalHeader, ModalActions, P, Colors, H5, Card, H6} from '../UI/index.js'
import Address from '../addresses/Address.js'
import ReasonsSettings from '../orders/ReasonsSettings.js'
import {FormRow, FormStack, Input, Select, TextArea, Toggle, Option, CurrencyInput, formSpacing} from '../UI/forms/index.js'
import ParcelSettings from './ParcelSettings.js'
import Contacts from './Contacts.js'
import NewCustomer from 'server/functions/customers/NewCustomer.js'
import defaultEmailNotifications from 'server/models/resellerDefaults/defaultEmailNotifications.js'
import {Carrier, Customer, CustomersObject, Partner, Reseller, User} from 'types/types.js'
import Languages from '@utils/Languages.js'
import {SelectChangeEvent} from '@components/UI/forms/Select.js'
import dbCodes from 'server/dbCodes.js'
import t from 'src/helpers/Languages.js'
import naturalSortBy from 'src/utils/naturalSortBy.js'
import {getAvailableBranches} from 'src/utils/branches.js'
import type {PopupRef} from '../UI/overlays/Popup.js'
const emailNotifications = defaultEmailNotifications()

const days = {
    0: 'M',
    1: 'D',
    2: 'W',
    3: 'D',
    4: 'V',
    5: 'Z',
    6: 'Z'
}

const dayToLabel = {
    monday: 'M',
    tuesday: 'D',
    wednesday: 'W',
    thursday: 'D',
    friday: 'V',
    saturday: 'Z',
    sunday: 'Z'
}

interface CustomerModalProps {
    reseller: Reseller
    customers: CustomersObject
    carriers: Carrier[]
    partners?: Record<string, Partner>
    user: User
    id: string
}

interface CustomerModalState {
    modalIsOpen: boolean
    customer: Customer & {
        address?: Customer['address'] & {
            save?: boolean
        }
    }
    loading: boolean
    message: string
    error: string
    mailLoading: boolean
    mailMessage: string
    mailError: string
    tab: string
    validation: {
        loginEmail?: boolean
    }
}

class CustomerModal extends React.Component<CustomerModalProps, CustomerModalState> {
    initialState: CustomerModalState
    popup: PopupRef
    address: Address
    contacts: Contacts

    constructor(props: CustomerModalProps) {
        super(props)
        this.initialState = {
            modalIsOpen: false,
            customer: NewCustomer(),
            loading: false,
            message: '',
            error: '',
            mailLoading: false,
            mailMessage: '',
            mailError: '',
            tab: 'gegevens',
            validation: {}
        }

        this.state = structuredClone(this.initialState)
    }

    open(customer: Customer) {
        customer = customer ? structuredClone(customer) : this.state.customer

        console.log(customer)

        this.setState({
            modalIsOpen: true,
            customer
        })
    }

    close() {
        this.setState(this.initialState)
    }

    onChangeValue(path: string, event: SelectChangeEvent) {
        const {reseller} = this.props
        const customer = {...this.state.customer}

        if (path === 'email' || path === 'loginEmail') {
            event.target.value = event.target.value.toLowerCase().replace(/\s+/g, '')
        }

        if (path === 'settings.webhookURL' || path === 'settings.parcelWebhookURL') {
            event.target.value = event.target.value.toLowerCase()
        }

        if (path === 'settings.orders.emailNotificationsCustomerOption' && event.target.value === 'other' && !customer.settings.orders.emailNotificationsCustomer.length) {
            customer.settings.orders.emailNotificationsCustomer = reseller.settings.orders.emailNotifications.defaultNotificationsCustomer
        }

        if (path === 'settings.orders.emailNotificationsReceiverOption' && event.target.value === 'other' && !customer.settings.orders.emailNotificationsReceiver.length) {
            customer.settings.orders.emailNotificationsReceiver = reseller.settings.orders.emailNotifications.defaultNotificationsReceiver
        }

        if (event.target.values) {
            _.set(customer, path, event.target.values)
        } else {
            _.set(customer, path, event.target.value)
        }

        this.setState({customer})
    }

    onChangeDisabledCarrier(partnerId: string, enabled: boolean) {
        const customer = {...this.state.customer}

        const disabledCarriers = (customer.settings.orders.disabledCarriers || []).filter((id) => id !== partnerId)

        if (!enabled) {
            disabledCarriers.push(partnerId)
        }

        _.set(customer, 'settings.orders.disabledCarriers', disabledCarriers)

        this.setState({customer})
    }

    onChangeChecked(path: string, event: {target: {checked: boolean}}) {
        const customer = {...this.state.customer}

        _.set(customer, path, event.target.checked)

        if (path === 'permissions.ordersRead' && !event.target.checked) {
            _.set(customer, 'permissions.orders', event.target.checked)
        }

        if (path === 'permissions.orders' && event.target.checked) {
            _.set(customer, 'permissions.ordersRead', event.target.checked)
        }

        this.setState({customer})
    }

    onAddressChange(address) {
        const customer = {...this.state.customer}

        customer.name = address.name
        customer.address = address

        this.setState({customer})
    }

    onReasonsSettingsChange(customer) {
        this.setState({customer})
    }

    onContactsChange(contacts) {
        const customer = {...this.state.customer}

        customer.contacts = contacts

        this.setState({customer})
    }

    onClickGenerateApiKey() {
        const customer = {...this.state.customer}

        if (!customer.settings.apiKey) {
            customer.settings.apiKey = generateUUID()
            this.setState({customer})
        } else {
            this.popup.open('Genereer nieuwe API key', 'De oude API key is hierna niet meer geldig! Bestaande koppelingen werken hierdoor niet meer.', () => {
                this.popup.close()
                customer.settings.apiKey = generateUUID()
                this.setState({customer})
            })
        }
    }

    onOpeningHoursChange(day, event) {
        const customer = {...this.state.customer}

        customer.settings.openingHours[day].open = event.target.checked

        this.setState({customer})
    }

    onClickRemoveApiKey() {
        const customer = {...this.state.customer}

        if (customer.settings.apiKey) {
            this.popup.open('Verwijder API key', 'De API key wordt verwijderd, bestaande koppelingen werken hierdoor niet meer.', () => {
                this.popup.close()
                customer.settings.apiKey = ''
                customer.settings.webhookURL = ''
                customer.settings.parcelWebhookURL = ''
                this.setState({customer})
            })
        }
    }

    onClickGenerateHmacSecret() {
        const customer = {...this.state.customer}

        if (!customer.settings.hmacSecret) {
            customer.settings.hmacSecret = generateUUID()
            this.setState({customer})
        } else {
            this.popup.open('Genereer nieuwe HMAC key', 'De oude HMAC key is hierna niet meer geldig, bestaande koppelingen werken hierdoor niet meer.', () => {
                this.popup.close()
                customer.settings.hmacSecret = generateUUID()
                this.setState({customer})
            })
        }
    }

    onClickRemoveHmacSecret() {
        const customer = {...this.state.customer}

        if (customer.settings.hmacSecret) {
            this.popup.open('Verwijder HMAC key', 'De HMAC key wordt verwijderd, bestaande koppelingen werken hierdoor niet meer.', () => {
                this.popup.close()
                customer.settings.hmacSecret = ''
                this.setState({customer})
            })
        }
    }

    async onClickCopy(text) {
        if (navigator && navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(text)
            } catch (err) {
                console.log(err)
            }
        }
    }

    onSendWelcomeMail() {
        const customer = {...this.state.customer}
        this.setState({mailLoading: true, mailMessage: '', mailError: ''})

        let promise = Promise.resolve()

        if (!customer._id) {
            this.setState({loading: true, error: ''})

            promise = new Promise((resolve, reject) => {
                CustomerActions.create(customer, (err, createdCustomer) => {
                    if (err) {
                        reject(err)
                    } else {
                        // Keep the _id, so saving the modal afterwards edits this customer instead of creating it again
                        this.setState({customer: {...this.state.customer, ...createdCustomer}})
                        resolve()
                    }
                })
            })
        } else {
            this.setState({loading: true, error: ''})

            promise = new Promise((resolve, reject) => {
                CustomerActions.edit(customer, (err) => {
                    if (err) {
                        reject(err)
                    } else {
                        resolve()
                    }
                })
            })
        }

        promise.then(() => {
            LoginActions.sendCustomerWelcomeMail(customer, (err, response) => {
                if (err) {
                    this.setState({loading: false, mailLoading: false, mailError: err})
                } else {
                    this.setState({loading: false, mailLoading: false, mailMessage: response})
                }
            })
        }).catch((err) => {
            this.setState({loading: false, error: err, mailLoading: false})
        })
    }

    async onSubmit(event) {
        event.preventDefault()

        if (await this.validate()) {
            const customer = {...this.state.customer}
            this.setState({loading: true, error: '', message: ''})

            if (customer._id) {
                CustomerActions.edit(customer, this.response.bind(this))
            } else {
                CustomerActions.create(customer, this.response.bind(this))
            }

            if (customer.address.save) {
                AddressActions.update([customer.address])
            }
        }
    }

    response(err) {
        if (err) {
            this.setState({error: err, loading: false})
        } else {
            this.close()
        }
    }

    async validate() {
        const {id = '', reseller} = this.props
        const {customer} = this.state
        const validation: CustomerModalState['validation'] = {}
        let valid = true
        let addressValid = true
        let focusId = ''
        let tab = ''
        let error = ''

        if (customer.login && !customer.loginEmail) {
            valid = false
            focusId = `loginEmail${id}`
            validation.loginEmail = true
            tab = 'gegevens'
        }

        const hasOpenDays = _.some(Object.keys(customer.settings.openingHours), (day) => customer.settings.openingHours[day].open)

        if (!hasOpenDays) {
            valid = false
            error = 'Er zijn geen openingsdagen ingesteld.'
            tab = 'gegevens'
        }

        const hasPickupDays = !customer.settings.parcels.autoPickupOrder || _.some(Object.keys(customer.settings.openingHours), (day) => reseller.settings.account.openingHours[day].open && customer.settings.openingHours[day].open && customer.settings.parcels.pickupDays[day])

        if (hasOpenDays && !hasPickupDays) {
            valid = false
            error = 'Er zijn geen ophaaldagen ingesteld.'
            tab = 'zendingen'
        }

        if (valid) {
            await new Promise<void>((resolve) => {
                this.setState({tab: 'gegevens'}, () => {
                    tab = 'gegevens'
                    addressValid = this.address.validate()
                    resolve()
                })
            })
        }

        this.setState({validation, tab, error}, () => {
            if (focusId) {
                document.getElementById(focusId).focus()
            }
        })

        return addressValid && valid
    }

    onReset2FA() {
        const {customer} = this.state
        this.popup.open('Reset 2FA methode', 'De klant zal de 2FA methode opnieuw moeten activeren. Inloggen met de huidige methode zal niet meer mogelijk zijn. Weet je zeker dat je door wil gaan?', () => {
            this.popup.setLoading(true)

            CustomerActions.reset2FA(customer._id, (err, updatedCustomer) => {
                if (err) {
                    // The modal's own error would be hidden behind the open popup
                    this.popup.setError(err)
                } else {
                    this.setState({customer: updatedCustomer}, () => {
                        this.popup.close()
                    })
                }
            })
        })
    }

    // The main customer that invoices this customer (see invoiceForCustomers)
    invoiceMainCustomer(): Customer | undefined {
        const {customers} = this.props
        const {customer} = this.state

        return customer._id ? Object.values(customers || {}).find((mainCustomer) => mainCustomer.invoiceForCustomers?.includes(customer._id)) : undefined
    }

    // A customer is either a main customer or linked to one main customer, so only customers that are neither can be chosen
    invoiceForCustomerOptions() {
        const {customers} = this.props
        const {customer} = this.state

        const allCustomers = Object.values(customers || {})

        return allCustomers.filter((otherCustomer) => {
            if (customer.invoiceForCustomers?.includes(otherCustomer._id)) {
                return true
            }

            if (otherCustomer._id === customer._id || otherCustomer.isArchived || otherCustomer.invoiceForCustomers?.length) {
                return false
            }

            return !allCustomers.some((mainCustomer) => mainCustomer._id !== customer._id && mainCustomer.invoiceForCustomers?.includes(otherCustomer._id))
        }).map((otherCustomer) => ({value: otherCustomer._id, title: otherCustomer.name}))
    }

    render() {
        const {customer, message, error, loading, modalIsOpen, tab, mailLoading, mailMessage, mailError} = this.state
        const {reseller, carriers, user, id = ''} = this.props
        // Only partners this reseller forwards orders to
        const partners = _.pickBy(this.props.partners || {}, (partner) => reseller.settings.outgoingPartners?.some((connection) => connection._id === partner._id && connection.status === 'active'))

        const invoiceMainCustomer = this.invoiceMainCustomer()
        // A customer invoiced via a main customer keeps its own debtor code, but is invoiced with the invoice debtor code
        // and administration settings of the main customer
        const invoiceCustomer = invoiceMainCustomer || customer
        // The minimum revenue is calculated over the whole group with the amount of the main customer, or for every
        // customer separately with its own amount
        const minimumRevenueCustomer = invoiceMainCustomer?.settings.orders.minimumRevenueCombined ? invoiceMainCustomer : customer

        const notificationKeysReceiver = Object.keys(emailNotifications).filter((key) => !key.includes('customer') && emailNotifications[key].constructor === Object)
        const notificationKeysCustomer = Object.keys(emailNotifications).filter((key) => key.includes('customer') && emailNotifications[key].constructor === Object)

        const notificationsReceiver = notificationKeysReceiver.map((notificationKey) => ({
            value: notificationKey,
            title: emailNotifications[notificationKey].label
        }))

        const notificationsCustomer = notificationKeysCustomer.map((notificationKey) => ({
            value: notificationKey,
            title: emailNotifications[notificationKey].label
        }))

        const pickupNotPossibleReasonsHasDefault = customer?.settings?.orders?.pickupNotPossibleReasons?.includes('default')

        const deliveryNotPossibleReasonsHasDefault = customer?.settings?.orders?.deliveryNotPossibleReasons?.includes('default')

        return (
            <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                <ModalHeader title={customer._id ? 'Bewerk klant' : 'Nieuwe klant'} onClose={this.close.bind(this)} />

                <form onSubmit={this.onSubmit.bind(this)}>
                    <Tabs style={{marginBottom: 30}} value={tab} onChange={(event) => this.setState({tab: event.target.value})}>
                        <Tab value='gegevens'>Gegevens</Tab>

                        <Tab value='contactpersonen'>Contactpersonen</Tab>

                        {reseller.permissions.orders &&
                            <Tab value='ritten'>Ritten</Tab>
                        }

                        {reseller.permissions.parcels &&
                            <Tab value='zendingen'>Zendingen</Tab>
                        }

                        <Tab value='koppelingen'>Koppelingen</Tab>
                    </Tabs>

                    {tab === 'gegevens' &&
                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <FormRow>
                                <Input
                                    style={{flex: 1}}
                                    label='Debiteurnummer'
                                    info={customer._id && reseller.settings.administration.api ? 'Het debiteurnummer is niet aanpasbaar als er een koppeling is met een boekhoudsysteem.' : ''}
                                    value={customer.debtorCode}
                                    disabled={!!reseller.settings.administration.api}
                                    onChange={this.onChangeValue.bind(this, 'debtorCode')}
                                />

                                <FormStack style={{flex: 1}}>
                                    {getAvailableBranches(reseller).length > 0 &&
                                        <Select
                                            label={t('branch')}
                                            value={customer.branchId || ''}
                                            options={getAvailableBranches(reseller).map((branch) => {
                                                return {value: branch.id, title: branch.name}
                                            })}
                                            onChange={this.onChangeValue.bind(this, 'branchId')}
                                            allowEmpty
                                        />
                                    }
                                </FormStack>
                            </FormRow>

                            {reseller.settings.administration.api === 'WeFact' &&
                                <FormRow>
                                    <Toggle
                                        label='Afwijkend debiteurnummer facturatie'
                                        info='Zet deze optie aan als voor deze klant op een ander debiteurnummer gefactureerd moet worden.'
                                        checked={invoiceCustomer.useOtherInvoiceDebtorCode}
                                        disabled={!!invoiceMainCustomer}
                                        onChange={this.onChangeChecked.bind(this, 'useOtherInvoiceDebtorCode')}
                                    />

                                    <FormStack style={{flex: 1}}>
                                        {invoiceCustomer.useOtherInvoiceDebtorCode &&
                                            <Input
                                                label='Debiteurnummer facturatie'
                                                info=''
                                                value={invoiceCustomer.invoiceDebtorCode}
                                                disabled={!!invoiceMainCustomer}
                                                onChange={this.onChangeValue.bind(this, 'invoiceDebtorCode')}
                                            />
                                        }
                                    </FormStack>
                                </FormRow>
                            }

                            <Address
                                disabled={customer._id && reseller.settings.administration.api && reseller.settings.administration.customersNotEditable && !(customer.dontOverrideAddressOnSync && user.permissions.invoices)}
                                address={customer.address}
                                noTAV
                                businessCheckbox
                                allowAttachments={true}
                                onChange={this.onAddressChange.bind(this)}
                                ref={(ref) => this.address = ref}
                            />

                            {reseller.settings.administration.api && user.permissions.invoices &&
                                <Toggle
                                    style={{width: '50%'}}
                                    label={`Adres niet synchroniseren met ${reseller.settings.administration.api}`}
                                    checked={customer.dontOverrideAddressOnSync}
                                    onChange={this.onChangeChecked.bind(this, 'dontOverrideAddressOnSync')}
                                />
                            }

                            <FormRow style={{marginTop: formSpacing.section}}>
                                <Input
                                    label='Telefoon'
                                    value={customer.phone}
                                    onChange={this.onChangeValue.bind(this, 'phone')}
                                />

                                <Input
                                    label='Emailadres'
                                    value={customer.email}
                                    onChange={this.onChangeValue.bind(this, 'email')}
                                />
                            </FormRow>

                            <FormRow style={{alignItems: 'center'}}>
                                <P style={{flex: 1}}>Geopend op</P>

                                <div style={{display: 'flex', flex: 1}}>
                                    {_.keys(customer.settings.openingHours).map((key, index) => {
                                        return (
                                            <Option
                                                key={key}
                                                label={days[index]}
                                                checked={customer.settings.openingHours[key].open}
                                                onChange={this.onOpeningHoursChange.bind(this, key)}
                                            />
                                        )
                                    })}
                                </div>
                            </FormRow>

                            <H5 style={{marginBottom: 12, marginTop: 24}}>{t('invoiceTogether')}</H5>

                            {invoiceMainCustomer ?
                                <Alert variant='info' style={{marginBottom: 12}}>{`${t('invoicedViaMainCustomer')} ${invoiceMainCustomer.name}.`}</Alert> :
                                <Select
                                    label={t('invoiceForCustomers')}
                                    info={t('invoiceForCustomersInfo')}
                                    values={customer.invoiceForCustomers || []}
                                    options={this.invoiceForCustomerOptions()}
                                    onChange={this.onChangeValue.bind(this, 'invoiceForCustomers')}
                                />
                            }

                            {reseller.accountType === 'carrierPlus' &&
                                <>
                                    <H5 style={{marginBottom: 12, marginTop: 24}}>Klantportaal</H5>

                                    <FormRow>
                                        <Toggle
                                            label={Languages.enable['NL']}
                                            checked={customer.login}
                                            onChange={this.onChangeChecked.bind(this, 'login')}
                                        />

                                        <FormStack style={{flex: 1}}>
                                            {customer.login &&
                                                <Input
                                                    id={`loginEmail${id}`}
                                                    label='Emailadres klantlogin'
                                                    value={customer.loginEmail}
                                                    onChange={this.onChangeValue.bind(this, 'loginEmail')}
                                                    isInvalid={this.state.validation.loginEmail}
                                                />
                                            }
                                        </FormStack>
                                    </FormRow>

                                    {customer.login &&
                                        <>
                                            <FormRow>
                                                <Toggle
                                                    label={Languages.parcels['NL']}
                                                    checked={customer.permissions?.parcels}
                                                    onChange={this.onChangeChecked.bind(this, 'permissions.parcels')}
                                                />
                                                <div style={{flex: 1}} />
                                            </FormRow>

                                            <FormRow>
                                                <Toggle
                                                    label={Languages.ordersRead['NL']}
                                                    checked={customer.permissions?.ordersRead}
                                                    onChange={this.onChangeChecked.bind(this, 'permissions.ordersRead')}
                                                />
                                                <div style={{flex: 1}} />
                                            </FormRow>

                                            <FormRow>
                                                <Toggle
                                                    label={Languages.ordersWrite['NL']}
                                                    checked={customer.permissions?.orders}
                                                    onChange={this.onChangeChecked.bind(this, 'permissions.orders')}
                                                />
                                                <div style={{flex: 1}} />
                                            </FormRow>
                                        </>
                                    }

                                    {customer.login && customer.settings.mfaRequired && (
                                        <FormRow style={{alignItems: 'baseline'}}>
                                            {!customer.mfaEnabled ?
                                                <P>Deze klant moet bij de volgende login tweefactorauthenticatie instellen.</P> :
                                                user.isOwner ?
                                                    (
                                                        <>
                                                            <P style={{flex: 1}}>Deze klant heeft tweefactorauthenticatie geactiveerd.</P>

                                                            <div style={{flex: 1}}>
                                                                <Button
                                                                    style={{marginBottom: 12}}
                                                                    onClick={this.onReset2FA.bind(this)}
                                                                    variant='outline-white'
                                                                >
                                                                    Reset 2FA
                                                                </Button>
                                                            </div>
                                                        </>
                                                    ) :
                                                    <P>Deze klant heeft tweefactorauthenticatie geactiveerd. Het eigenaar-account van Veloyd kan de 2FA methode resetten. Het eigenaar-account is: {reseller.ownerEmail}.</P>
                                            }
                                        </FormRow>
                                    )}
                                </>
                            }

                            {reseller.settings.shifts?.shiftbase?.enabled && (reseller.settings.shifts.shiftbase?.departmentConnectedTo === 'customer' || reseller.settings.shifts.shiftbase?.teamConnectedTo === 'customer') &&
                                <>
                                    <H5 style={{marginTop: 24, marginBottom: 12}}>Shiftbase</H5>

                                    <FormRow style={{marginBottom: formSpacing.section}}>
                                        <Select
                                            label='Shiftbase afdeling'
                                            fetch={async () => {
                                                const response = await fetch('https://api.shiftbase.com/api/departments', {
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                        'Accept': 'application/json',
                                                        'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                    }
                                                })

                                                const shiftbaseDepartments = (await response.json())?.data || []

                                                return shiftbaseDepartments.map((department) => {
                                                    return {
                                                        title: department.Department.name,
                                                        value: department.Department.id
                                                    }
                                                })
                                            }}
                                            value={(customer.meta?.shiftbaseDepartmentId || '') as string}
                                            onChange={(event) => this.onChangeValue('meta.shiftbaseDepartmentId', event)}
                                            allowEmpty
                                        />

                                        <FormStack style={{flex: 1}}>
                                            {reseller.settings.shifts.shiftbase?.teamConnectedTo === 'customer' && customer.meta?.shiftbaseDepartmentId &&
                                                <Select
                                                    label='Shiftbase team'
                                                    fetch={async () => {
                                                        const response = await fetch(`https://api.shiftbase.com/api/departments/${customer.meta?.shiftbaseDepartmentId}`, {
                                                            headers: {
                                                                'Content-Type': 'application/json',
                                                                'Accept': 'application/json',
                                                                'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                            }
                                                        })

                                                        const shiftbaseDepartment = (await response.json())?.data || {}

                                                        return shiftbaseDepartment.Team?.map((team) => {
                                                            return {
                                                                title: team.name,
                                                                value: team.id
                                                            }
                                                        }) || []
                                                    }}
                                                    fetchTrigger={customer.meta?.shiftbaseDepartmentId as string}
                                                    value={(customer.meta?.shiftbaseTeamId || '') as string}
                                                    onChange={(event) => this.onChangeValue('meta.shiftbaseTeamId', event)}
                                                    allowEmpty
                                                />
                                            }
                                        </FormStack>
                                    </FormRow>
                                </>
                            }

                            <TextArea
                                label='Notities'
                                rows={4}
                                value={customer.notes}
                                onChange={this.onChangeValue.bind(this, 'notes')}
                            />
                        </FormStack>
                    }

                    {tab === 'contactpersonen' &&
                        <Contacts
                            contacts={customer.contacts}
                            onChange={this.onContactsChange.bind(this)}
                            ref={(ref) => this.contacts = ref}
                        />
                    }

                    {tab === 'ritten' &&
                        <FormStack style={{marginBottom: formSpacing.rowGap}}>
                            <H5 style={{marginBottom: 12}}>Ritopties</H5>

                            <Select
                                copy
                                label='Bezorggebied'
                                info='Dit bezorggebied wordt gebruikt voor het aanmelden van ritten via de API.'
                                options={reseller.settings.deliveryZones.map((area) => {
                                    return {value: area.id, title: area.name}
                                })}
                                values={customer.settings.orders.deliveryZones || []}
                                onChange={this.onChangeValue.bind(this, 'settings.orders.deliveryZones')}
                            />

                            {reseller.permissions.network && Object.keys(partners || {}).length > 0 &&
                                <>
                                    <H6 style={{marginTop: 12, marginBottom: 0}}>Vervoerders</H6>

                                    <Toggle
                                        label='Ritten automatisch doorzetten'
                                        info='Ritten van deze klant worden automatisch doorgezet naar een vervoerder wanneer de rit binnen het bezorggebied van de vervoerder valt en automatisch doorzetten voor de vervoerder aan staat.'
                                        checked={customer.settings.orders.autoForwardOrders !== false}
                                        onChange={this.onChangeChecked.bind(this, 'settings.orders.autoForwardOrders')}
                                    />

                                    {Object.values(partners).map((partner) => {
                                        return (
                                            <Toggle
                                                key={partner._id}
                                                label={partner.name}
                                                checked={!(customer.settings.orders.disabledCarriers || []).includes(partner._id)}
                                                onChange={(event) => this.onChangeDisabledCarrier(partner._id, event.target.checked)}
                                            />
                                        )
                                    })}
                                </>
                            }

                            <Select
                                label='Adressen bij nieuwe rit'
                                info='Kies hier welke adressen standaard zichtbaar zijn bij het aanmaken van een nieuwe rit.'
                                options={[
                                    {
                                        value: 'default',
                                        title: 'Gebruik standaard instelling'
                                    },
                                    {
                                        value: 'deliver',
                                        title: 'Alleen bezorgadres'
                                    },
                                    {
                                        value: 'pickup',
                                        title: 'Alleen ophaaladres'
                                    },
                                    {
                                        value: 'pickupAndDeliver',
                                        title: 'Ophaal- en bezorgadres'
                                    }
                                ]}
                                value={customer.settings.orders.defaultAddresses}
                                onChange={this.onChangeValue.bind(this, 'settings.orders.defaultAddresses')}
                            />

                            <FormRow>
                                <Select
                                    label='Standaard opties ophaaladres'
                                    value={typeof customer.settings.orders.defaultPickupOptions === 'string' ? customer.settings.orders.defaultPickupOptions : undefined}
                                    values={Array.isArray(customer.settings.orders.defaultPickupOptions) ? customer.settings.orders.defaultPickupOptions : undefined}
                                    options={[
                                        {value: 'default', title: 'Gebruik standaard instelling'},
                                        {value: 'none', title: 'Geen opties'},
                                        ...Object.entries(dbCodes.pickupOptions).map(([key, value]) => ({
                                            value: key,
                                            title: value
                                        })),
                                        ...(reseller.settings.orders.customOptions || []).map((option) => ({
                                            value: option.id,
                                            title: option.name,
                                            icon: 'mdi mdi-circle',
                                            iconColor: option.color,
                                            showIconInValue: true
                                        }))
                                    ]}
                                    onChange={(event) => {
                                        const {value, values} = event.target

                                        if (
                                            value === 'default' ||
                                            (Array.isArray(values) && values.includes('default')) ||
                                            (Array.isArray(values) && values.length === 0)
                                        ) {
                                            event.target.value = 'default'
                                            event.target.values = undefined
                                            this.onChangeValue('settings.orders.defaultPickupOptions', event)
                                            return
                                        }

                                        if (
                                            value === 'none' ||
                                            (Array.isArray(values) && values.includes('none'))
                                        ) {
                                            event.target.value = 'none'
                                            event.target.values = undefined
                                            this.onChangeValue('settings.orders.defaultPickupOptions', event)
                                            return
                                        }

                                        if (!values) {
                                            event.target.values = [value]
                                            event.target.value = undefined
                                            this.onChangeValue('settings.orders.defaultPickupOptions', event)
                                            return
                                        }

                                        this.onChangeValue('settings.orders.defaultPickupOptions', event)
                                    }}

                                />

                                <Select
                                    label='Standaard opties bezorgadres'
                                    value={typeof customer.settings.orders.defaultDeliveryOptions === 'string' ? customer.settings.orders.defaultDeliveryOptions : undefined}
                                    values={Array.isArray(customer.settings.orders.defaultDeliveryOptions) ? customer.settings.orders.defaultDeliveryOptions : undefined}
                                    options={[
                                        {value: 'default', title: 'Gebruik standaard instelling'},
                                        {value: 'none', title: 'Geen opties'},
                                        ...Object.entries(dbCodes.pickupAndDeliveryOptions).map(([key, value]) => ({
                                            value: key,
                                            title: value
                                        })),
                                        ...reseller.settings.orders.customOptions.map((option) => ({
                                            value: option.id,
                                            title: option.name,
                                            icon: 'mdi mdi-circle',
                                            iconColor: option.color,
                                            showIconInValue: true
                                        }))
                                    ]}
                                    onChange={(event) => {
                                        const {value, values} = event.target

                                        if (
                                            value === 'default' ||
                                            (Array.isArray(values) && values.includes('default')) ||
                                            (Array.isArray(values) && values.length === 0)
                                        ) {
                                            event.target.value = 'default'
                                            event.target.values = undefined
                                            this.onChangeValue('settings.orders.defaultDeliveryOptions', event)
                                            return
                                        }

                                        if (
                                            value === 'none' ||
                                            (Array.isArray(values) && values.includes('none'))
                                        ) {
                                            event.target.value = 'none'
                                            event.target.values = undefined
                                            this.onChangeValue('settings.orders.defaultDeliveryOptions', event)
                                            return
                                        }

                                        if (!values) {
                                            event.target.values = [value]
                                            event.target.value = undefined
                                            this.onChangeValue('settings.orders.defaultDeliveryOptions', event)
                                            return
                                        }

                                        this.onChangeValue('settings.orders.defaultDeliveryOptions', event)
                                    }}
                                />
                            </FormRow>

                            <Select
                                label='Beschikbare collo typen'
                                value={typeof customer.settings.orders.allowedColliTypes === 'string' ? customer.settings.orders.allowedColliTypes : undefined}
                                values={Array.isArray(customer.settings.orders.allowedColliTypes) ? customer.settings.orders.allowedColliTypes : undefined}
                                options={[
                                    {value: 'default', title: 'Gebruik standaard instelling'},
                                    ...(reseller.settings.orders.colliTypes || []).map((type) => ({
                                        value: type.id,
                                        title: type.name
                                    }))
                                ]}
                                onChange={(event) => {
                                    const {value, values} = event.target

                                    if (
                                        value === 'default' ||
                                        (Array.isArray(values) && values.includes('default')) ||
                                        (Array.isArray(values) && values.length === 0)
                                    ) {
                                        event.target.value = 'default'
                                        event.target.values = undefined
                                        this.onChangeValue('settings.orders.allowedColliTypes', event)
                                        return
                                    }

                                    if (!values) {
                                        event.target.values = [value]
                                        event.target.value = undefined
                                        this.onChangeValue('settings.orders.allowedColliTypes', event)
                                        return
                                    }

                                    this.onChangeValue('settings.orders.allowedColliTypes', event)
                                }}

                            />

                            <Card
                                style={{
                                    backgroundColor: pickupNotPossibleReasonsHasDefault ? '' : Colors.backgroundNeutral2,
                                    border: 'none',
                                    ...(pickupNotPossibleReasonsHasDefault ? {padding: 0} : {padding: formSpacing.inset})
                                }}
                            >
                                <FormStack>
                                    <Select
                                        label={'Redenen voor \'Ophalen niet mogelijk \''}
                                        options={[
                                            {
                                                value: 'default',
                                                title: 'Gebruik standaard instelling'
                                            },
                                            {
                                                value: 'custom',
                                                title: 'Aangepast'
                                            }
                                        ]}
                                        value={pickupNotPossibleReasonsHasDefault ? 'default' : 'custom'}
                                        onChange={(event) => {
                                            customer.settings.orders.pickupNotPossibleReasons = [
                                                ...event.target.value === 'default' ? ['default'] : []
                                            ]
                                            customer.settings.orders.pickupNotPossibleReasonsSpecifications = []
                                            this.onReasonsSettingsChange(customer)
                                        }}
                                    />
                                    {!pickupNotPossibleReasonsHasDefault &&
                                        <ReasonsSettings
                                            reseller={reseller}
                                            customer={customer}
                                            onChange={this.onReasonsSettingsChange.bind(this)}
                                            type='pickup'
                                        />
                                    }
                                </FormStack>
                            </Card>

                            <Card
                                style={{
                                    backgroundColor: deliveryNotPossibleReasonsHasDefault ? '' : Colors.backgroundNeutral2,
                                    border: 'none',
                                    ...(deliveryNotPossibleReasonsHasDefault ? {padding: 0} : {padding: formSpacing.inset})
                                }}
                            >
                                <FormStack>
                                    <Select
                                        label={'Redenen voor \'Bezorgen niet mogelijk \''}
                                        options={[
                                            {
                                                value: 'default',
                                                title: 'Gebruik standaard instelling'
                                            },
                                            {
                                                value: 'custom',
                                                title: 'Aangepast'
                                            }
                                        ]}
                                        value={deliveryNotPossibleReasonsHasDefault ? 'default' : 'custom'}
                                        onChange={(event) => {
                                            customer.settings.orders.deliveryNotPossibleReasons = [
                                                ...event.target.value === 'default' ? ['default'] : []
                                            ]
                                            customer.settings.orders.deliveryNotPossibleReasonsSpecifications = []
                                            this.onReasonsSettingsChange(customer)
                                        }}
                                    />
                                    {!deliveryNotPossibleReasonsHasDefault &&
                                        <ReasonsSettings
                                            reseller={reseller}
                                            customer={customer}
                                            onChange={this.onReasonsSettingsChange.bind(this)}
                                            type='delivery'
                                        />
                                    }
                                </FormStack>
                            </Card>

                            <Select
                                label='Collo toevoegen toestaan'
                                value={customer.settings.orders.allowAddCollo}
                                onChange={this.onChangeValue.bind(this, 'settings.orders.allowAddCollo')}
                            >
                                <option value='default'>{`Gebruik standaard instelling (${reseller.settings.allowAddCollo === 'yes' ? 'Ja' : (reseller.settings.allowAddCollo === 'deliver' ? 'Alleen bij bezorgen' : (reseller.settings.allowAddCollo === 'pickup' ? 'Alleen bij ophalen' : 'Nee'))})`}</option>
                                <option value='yes'>Ja</option>
                                <option value='deliver'>Alleen bezorgen</option>
                                <option value='pickup'>Alleen bij ophalen</option>
                                <option value=''>Nee</option>
                            </Select>

                            <FormRow>
                                <TextArea
                                    label='Instructies bij nieuwe rit voor planner'
                                    info='Deze instructies worden weergegeven bij het aanmaken van een nieuwe rit voor deze klant.'
                                    value={customer.settings.orders.newOrderInstructions}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.newOrderInstructions')}
                                />

                                <TextArea
                                    label='Standaard opmerking bij nieuwe rit'
                                    value={customer.settings.orders.defaultOrderNotes}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.defaultOrderNotes')}
                                />
                            </FormRow>

                            <H5 style={{marginBottom: 12, marginTop: 36}}>Administratie</H5>

                            {invoiceMainCustomer &&
                                <Alert variant='info' style={{marginBottom: 12}}>{`${t('invoicedViaMainCustomer')} ${invoiceMainCustomer.name}.`}</Alert>
                            }

                            <Select
                                label={t('defaultPriceTable')}
                                allowEmpty
                                value={invoiceCustomer.settings.orders.defaultPriceTable}
                                disabled={!!invoiceMainCustomer}
                                onChange={this.onChangeValue.bind(this, 'settings.orders.defaultPriceTable')}
                            >
                                {naturalSortBy(reseller.settings.orders.prices || [], 'name').map((priceTable) => {
                                    return (
                                        <option key={priceTable.id} value={priceTable.id}>{priceTable.name}</option>
                                    )
                                })}
                            </Select>

                            <FormRow>
                                <Select
                                    label='Toon prijsopbouw op facturen'
                                    value={invoiceCustomer.settings.orders.showPriceExplanation}
                                    disabled={!!invoiceMainCustomer}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.showPriceExplanation')}
                                    options={[
                                        {
                                            title: 'Gebruik standaard instelling',
                                            value: 'default'
                                        },
                                        {
                                            title: 'Ja',
                                            value: 'yes'
                                        },
                                        {
                                            title: 'Nee',
                                            value: ''
                                        }
                                    ]}
                                />

                                <Select
                                    label='Toon colli barcodes in prijsopbouw'
                                    info='Toont per collo de barcode, collo type en bijbehorende prijs (indien aanwezig volgens de tarieftabel).'
                                    value={customer.settings.orders.showColliBarcodeSpecification || 'default'}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.showColliBarcodeSpecification')}
                                    options={[
                                        {
                                            title: 'Gebruik standaard instelling',
                                            value: 'default'
                                        },
                                        {
                                            title: 'Ja',
                                            value: 'yes'
                                        },
                                        {
                                            title: 'Nee',
                                            value: ''
                                        }
                                    ]}
                                />
                            </FormRow>

                            <FormRow>
                                <Toggle
                                    label='Minimum omzet per dag'
                                    info='Als deze optie aanstaat wordt de omzet per dag uit ritten en diensten aangevuld tot het opgegeven bedrag. Deze optie is alleen van toepassing op dagen waarop ritten of diensten zijn uitgevoerd.'
                                    checked={invoiceCustomer.settings.orders.minimumRevenuePerDay}
                                    disabled={!!invoiceMainCustomer}
                                    onChange={this.onChangeChecked.bind(this, 'settings.orders.minimumRevenuePerDay')}
                                />

                                <FormRow style={{flex: 1}}>
                                    {invoiceCustomer.settings.orders.minimumRevenuePerDay &&
                                        <CurrencyInput
                                            label='Minimum omzet'
                                            value={minimumRevenueCustomer.settings.orders.minimumRevenueAmount || ''}
                                            disabled={minimumRevenueCustomer !== customer}
                                            onChange={this.onChangeValue.bind(this, 'settings.orders.minimumRevenueAmount')}
                                        />
                                    }

                                    {customer.settings.orders.minimumRevenuePerDay && customer.invoiceForCustomers?.length > 0 &&
                                        <Select
                                            label={t('minimumRevenueCombined')}
                                            value={customer.settings.orders.minimumRevenueCombined ? 'combined' : 'perCustomer'}
                                            options={[
                                                {value: 'perCustomer', title: t('minimumRevenuePerCustomer')},
                                                {value: 'combined', title: t('minimumRevenueAllCustomers')}
                                            ]}
                                            onChange={(event) => {
                                                const customer = {...this.state.customer}
                                                _.set(customer, 'settings.orders.minimumRevenueCombined', event.target.value === 'combined')
                                                this.setState({customer})
                                            }}
                                        />
                                    }
                                </FormRow>
                            </FormRow>

                            <FormRow>
                                <Toggle
                                    label='Referentie verplicht'
                                    checked={customer.settings.orders.referenceRequired}
                                    onChange={this.onChangeChecked.bind(this, 'settings.orders.referenceRequired')}
                                />

                                <Toggle
                                    label='Genereer referentie automatisch'
                                    checked={customer.settings.orders.generateReference}
                                    onChange={this.onChangeChecked.bind(this, 'settings.orders.generateReference')}
                                />
                            </FormRow>

                            <H5 style={{marginBottom: 12, marginTop: 36}}>Notificaties</H5>

                            <FormRow>
                                <Select
                                    label='Email notificaties ontvanger'
                                    value={customer.settings.orders.emailNotificationsReceiverOption}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.emailNotificationsReceiverOption')}
                                >
                                    <option value='default'>Gebruik standaard instelling</option>
                                    <option value='other'>Aangepast</option>
                                    <option value=''>Verstuur geen notificaties</option>
                                </Select>

                                <FormStack style={{flex: 1}}>
                                    {customer.settings.orders.emailNotificationsReceiverOption === 'other' && (
                                        <Select
                                            label='Aangepaste email notificaties ontvanger'
                                            values={customer.settings.orders.emailNotificationsReceiver}
                                            options={notificationsReceiver || []}
                                            onChange={this.onChangeValue.bind(this, 'settings.orders.emailNotificationsReceiver')}
                                        />
                                    )}
                                </FormStack>
                            </FormRow>

                            <FormRow>
                                <Select
                                    label='Email notificaties klant'
                                    value={customer.settings.orders.emailNotificationsCustomerOption}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.emailNotificationsCustomerOption')}
                                >
                                    <option value='default'>Gebruik standaard instelling</option>
                                    <option value='other'>Aangepast</option>
                                    <option value=''>Verstuur geen notificaties</option>
                                </Select>

                                <FormStack style={{flex: 1}}>
                                    {customer.settings.orders.emailNotificationsCustomerOption === 'other' && (
                                        <Select
                                            label='Aangepaste email notificaties klant'
                                            values={customer.settings.orders.emailNotificationsCustomer}
                                            options={notificationsCustomer || []}
                                            onChange={this.onChangeValue.bind(this, 'settings.orders.emailNotificationsCustomer')}
                                        />
                                    )}
                                </FormStack>
                            </FormRow>

                            <FormRow>
                                <Select
                                    label={t('deliveredEmailChoiceCustomer')}
                                    value={customer.settings.orders.deliveredEmailWithCustomerEmail || ''}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.deliveredEmailWithCustomerEmail')}
                                    options={[
                                        {value: '', title: t('useDefaultSetting')},
                                        {value: 'customerOnly', title: t('deliveredEmailCustomerOnly')},
                                        {value: 'both', title: t('deliveredEmailBoth')}
                                    ]}
                                />
                            </FormRow>

                            <FormRow>
                                <Select
                                    label='Toon melding bij nieuwe rit'
                                    value={customer.settings.orders.showNewOrderNotification}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.showNewOrderNotification')}
                                    options={[
                                        {
                                            value: 'default',
                                            title: 'Gebruik standaard instelling'
                                        },
                                        {
                                            title: 'Nooit',
                                            value: 'never'
                                        },
                                        {
                                            title: 'Alleen rit voor vandaag',
                                            value: 'onlyToday'
                                        },
                                        {
                                            title: 'Altijd',
                                            value: 'always'
                                        }
                                    ]}
                                />

                                <div style={{flex: 1}} />
                            </FormRow>
                        </FormStack>
                    }

                    {tab === 'zendingen' &&
                        <ParcelSettings
                            customer={customer}
                            invoiceMainCustomer={invoiceMainCustomer}
                            carriers={carriers}
                            reseller={reseller}
                            onChange={(customer) => this.setState({customer})}
                        />
                    }

                    {tab === 'koppelingen' &&
                        <FormStack style={{marginBottom: formSpacing.section}}>
                            <H6 style={{marginBottom: 0}}>API instellingen</H6>
                            <FormRow>
                                <Input
                                    style={{flex: 1}}
                                    label='API Key'
                                    readOnly
                                    value={customer.settings.apiKey || ''}
                                />

                                <div style={{display: 'flex', flex: 1}}>
                                    {!customer.settings.apiKey &&
                                        <Button
                                            variant='outline-white'
                                            icon='mdi mdi-plus'
                                            label='Nieuwe API key'
                                            onClick={this.onClickGenerateApiKey.bind(this)}
                                        />
                                    }

                                    {customer.settings.apiKey &&
                                        <IconButton onClick={this.onClickCopy.bind(this, customer.settings.apiKey)}>
                                            <i className='mdi mdi-content-copy' />
                                        </IconButton>
                                    }

                                    {customer.settings.apiKey &&
                                        <IconButton onClick={this.onClickRemoveApiKey.bind(this)}>
                                            <i className='mdi mdi-delete' />
                                        </IconButton>
                                    }
                                </div>
                            </FormRow>

                            {customer.settings.apiKey &&
                                <>
                                    <Input
                                        style={{flex: 1}}
                                        label='Webhook URL ritten'
                                        value={customer.settings.webhookURL || ''}
                                        onChange={this.onChangeValue.bind(this, 'settings.webhookURL')}
                                    />

                                    <Toggle
                                        label='Webhooks voor ETA wijzigingen'
                                        info='Zet deze instelling aan wanneer de klant voor elke ETA wijziging van een rit een nieuwe webhook wil ontvangen.'
                                        checked={customer.settings.sendETAWebhooks || false}
                                        onChange={(event) => this.onChangeChecked('settings.sendETAWebhooks', event)}
                                    />

                                    <Input
                                        style={{flex: 1}}
                                        label='Webhook URL zendingen'
                                        value={customer.settings.parcelWebhookURL || ''}
                                        onChange={this.onChangeValue.bind(this, 'settings.parcelWebhookURL')}
                                    />

                                    <Input
                                        style={{flex: 1}}
                                        label='Webhook Authorization header'
                                        value={customer.settings.webhookAuthHeader || ''}
                                        onChange={this.onChangeValue.bind(this, 'settings.webhookAuthHeader')}
                                    />

                                    <FormRow>
                                        <Input
                                            style={{flex: 1}}
                                            label='HMAC key'
                                            readOnly
                                            value={customer.settings.hmacSecret || ''}
                                        />

                                        <div style={{display: 'flex', flex: 1}}>
                                            {!customer.settings.hmacSecret &&
                                                <Button
                                                    variant='outline-white'
                                                    icon='mdi mdi-plus'
                                                    label='Nieuwe HMAC key'
                                                    onClick={this.onClickGenerateHmacSecret.bind(this)}
                                                />
                                            }

                                            {customer.settings.hmacSecret &&
                                                <IconButton onClick={this.onClickCopy.bind(this, customer.settings.hmacSecret)}>
                                                    <i className='mdi mdi-content-copy' />
                                                </IconButton>
                                            }

                                            {customer.settings.hmacSecret &&
                                                <IconButton onClick={this.onClickRemoveHmacSecret.bind(this)}>
                                                    <i className='mdi mdi-delete' />
                                                </IconButton>
                                            }
                                        </div>
                                    </FormRow>
                                </>
                            }

                            <H6 style={{marginTop: 24, marginBottom: 0}}>Pharmacom</H6>

                            <FormRow>
                                <Toggle
                                    label='Pharmacom koppeling actief'
                                    info='Voor gebruik van deze koppeling worden extra kosten in rekening gebracht. Neem contact op met Veloyd voor meer informatie.'
                                    checked={customer.settings.orders.pharmacomEnabled}
                                    onChange={this.onChangeChecked.bind(this, 'settings.orders.pharmacomEnabled')}
                                />

                                <div style={{flex: 1}} />
                            </FormRow>

                            {customer.settings.orders.pharmacomEnabled &&
                                <FormRow>
                                    <Select
                                        label='Type rit'
                                        options={[
                                            {value: 'delivery', title: 'Alleen bezorgrit'},
                                            {value: 'ab', title: 'Gecombineerde ophaal- en bezorgrit'},
                                            {value: 'pickupDelivery', title: 'Gebundelde ophaalrit en losse bezorgritten'}
                                        ]}
                                        value={customer.settings.orders.pharmacomOrderType}
                                        onChange={this.onChangeValue.bind(this, 'settings.orders.pharmacomOrderType')}
                                    />

                                    <div style={{flex: 1}} />
                                </FormRow>
                            }

                            <H6 style={{marginTop: 24, marginBottom: 0}}>Receptlocatie</H6>

                            <FormRow>
                                <Select
                                    label='Type rit'
                                    options={[
                                        {value: 'delivery', title: 'Alleen bezorgrit'},
                                        {value: 'ab', title: 'Gecombineerde ophaal- en bezorgrit'},
                                        {value: 'pickupDelivery', title: 'Gebundelde ophaalrit en losse bezorgritten'}
                                    ]}
                                    value={customer.settings.orders.receptlocatieOrderType}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.receptlocatieOrderType')}
                                />

                                <div style={{flex: 1}} />
                            </FormRow>

                            <FormRow>
                                <Input
                                    label='Header token'
                                    info='Dit token ontvang je van Receptlocatie'
                                    value={customer.settings.orders.receptlocatieHeaderToken}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.receptlocatieHeaderToken')}
                                />

                                <Input
                                    label='Data token'
                                    info='Dit token ontvang je van Receptlocatie'
                                    value={customer.settings.orders.receptlocatieDataToken}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.receptlocatieDataToken')}
                                />
                            </FormRow>

                            <H6 style={{marginTop: 24, marginBottom: 0}}>Apotheek Voorzorg</H6>

                            <FormRow>
                                <Select
                                    label='Type rit'
                                    options={[
                                        {value: 'delivery', title: 'Alleen bezorgrit'},
                                        {value: 'ab', title: 'Gecombineerde ophaal- en bezorgrit'},
                                        {value: 'pickupDelivery', title: 'Gebundelde ophaalrit en losse bezorgritten'}
                                    ]}
                                    value={customer.settings.orders.voorzorgOrderType}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.voorzorgOrderType')}
                                />

                                <div style={{flex: 1}} />
                            </FormRow>

                            <FormRow style={{alignItems: 'center', justifyContent: 'space-between'}}>
                                <P style={{flex: 1}}>Bezorgdagen Apotheek Voorzorg</P>

                                <div style={{display: 'flex', flex: 1}}>
                                    {_.keys(customer.settings.orders.voorzorgDeliveryDays).map((day) => {
                                        return (
                                            <Option
                                                key={day}
                                                label={dayToLabel[day]}
                                                checked={customer.settings.orders.voorzorgDeliveryDays[day]}
                                                disabled={!reseller.settings.account.openingHours[day].open}
                                                onChange={this.onChangeChecked.bind(this, `settings.orders.voorzorgDeliveryDays.${day}`)}
                                            />
                                        )
                                    })}
                                </div>
                            </FormRow>

                            <H6 style={{marginTop: 24, marginBottom: 0}}>nShift</H6>

                            <FormRow>
                                <Input
                                    style={{flex: 1}}
                                    label='nShift gebruikersnaam'
                                    value={customer.settings.orders.nshiftUsername || ''}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.nshiftUsername')}
                                />

                                <Input
                                    type='password'
                                    autoComplete='new-password'
                                    style={{flex: 1}}
                                    label='nShift wachtwoord'
                                    value={customer.settings.orders.nshiftPassword || ''}
                                    onChange={this.onChangeValue.bind(this, 'settings.orders.nshiftPassword')}
                                />
                            </FormRow>

                            <H6 style={{marginTop: 24, marginBottom: 0}}>Spits</H6>

                            {customer.settings.integrations?.[0]?.status === 'active' &&
                                <>

                                    <FormRow>
                                        <Select
                                            label='Type rit'
                                            options={[
                                                {value: 'delivery', title: 'Alleen bezorgrit'},
                                                {value: 'ab', title: 'Gecombineerde ophaal- en bezorgrit'},
                                                {value: 'pickupDelivery', title: 'Gebundelde ophaalrit en losse bezorgritten'}
                                            ]}
                                            value={customer.settings.integrations?.[0]?.orderType}
                                            onChange={this.onChangeValue.bind(this, 'settings.integrations.0.orderType')}
                                        />

                                        <Input
                                            label={Languages.apiKey['NL']}
                                            value={customer.settings.integrations?.[0]?.apiKey}
                                            readOnly
                                        />
                                    </FormRow>

                                    <FormRow style={{alignItems: 'center', justifyContent: 'space-between'}}>
                                        <P style={{flex: 1}}>Bezorgdagen Spits</P>

                                        <div style={{display: 'flex', flex: 1}}>
                                            {_.keys(customer.settings.integrations[0].deliveryDays).map((day) => {
                                                return (
                                                    <Option
                                                        key={day}
                                                        label={dayToLabel[day]}
                                                        checked={customer.settings.integrations[0].deliveryDays[day]}
                                                        disabled={!reseller.settings.account.openingHours[day].open}
                                                        onChange={this.onChangeChecked.bind(this, `settings.integrations.0.deliveryDays.${day}`)}
                                                    />
                                                )
                                            })}
                                        </div>
                                    </FormRow>
                                </>
                            }

                            {customer.settings.integrations?.[0]?.status !== 'active' ?
                                <Button
                                    variant='outline-white'
                                    label={Languages.enable['NL']}
                                    onClick={() => {
                                        customer.settings.integrations = customer.settings.integrations || []

                                        if (customer.settings.integrations[0]) {
                                            customer.settings.integrations[0].status = 'active'
                                        } else {
                                            customer.settings.integrations.push({
                                                type: 'order',
                                                name: 'spits',
                                                status: 'active',
                                                apiKey: generateUUID(),
                                                orderType: 'delivery',
                                                deliveryDays: {
                                                    monday: true,
                                                    tuesday: true,
                                                    wednesday: true,
                                                    thursday: true,
                                                    friday: true,
                                                    saturday: false,
                                                    sunday: false
                                                }
                                            })
                                        }

                                        this.setState({customer: {...customer}})
                                    }}
                                /> :
                                <Button
                                    variant='outline-white'
                                    label={Languages.disable['NL']}
                                    onClick={() => {
                                        customer.settings.integrations[0].status = 'inactive'

                                        this.setState({customer: {...customer}})
                                    }}
                                />
                            }
                        </FormStack>
                    }

                    {message &&
                        <Alert style={{marginBottom: 6}} variant='success'>{message}</Alert>
                    }
                    {error &&
                        <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>
                    }
                    {mailMessage &&
                        <Alert style={{marginBottom: 6}} variant='success'>{mailMessage}</Alert>
                    }
                    {mailError &&
                        <Alert style={{marginBottom: 6}} variant='danger'>{mailError}</Alert>
                    }

                    <ModalActions>
                        {customer.login && customer.loginEmail && tab === 'gegevens' &&
                            <Button
                                variant='text'
                                loading={mailLoading}
                                onClick={this.onSendWelcomeMail.bind(this)}
                            >
                                Verstuur welkomstmail
                            </Button>
                        }
                        <Button type='submit' loading={loading}>Opslaan</Button>
                    </ModalActions>
                </form>

                <Popup ref={(ref) => this.popup = ref} />
            </Modal>
        )
    }
}

function generateUUID() {
    let d = new Date().getTime()

    if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now()
    }

    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })

    return uuid
}

export default (CustomerModal)
